import { useState } from 'react'
import { CustomVerseEditorMenu, InsertCustomVerseMenu } from './CustomVerses'

export const VersesAndPhrasesMenu = ({ setShow }) => {
  const [creatingVerse, setCreatingVerse] = useState(false)

  return creatingVerse ? (
    <CustomVerseEditorMenu setCreatingVerse={setCreatingVerse} />
  ) : (
    <InsertCustomVerseMenu
      setShow={setShow}
      setCreatingVerse={setCreatingVerse}
    />
  )
}

export default VersesAndPhrasesMenu
